
import { Paper, CircularProgress, Tab, Tabs, Grid, InputLabel, Select, MenuItem, withStyles, Snackbar, SnackbarContent, Switch, Button, Checkbox } from '@material-ui/core';
import classNames from 'classnames';
import translate from '../../locales';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { bucketTypes, forceRotationResetTypes, styleWithCommonClasses } from '../../_constants/emparkConstants';
import { getBuckets, getBucketDefinitions, createBucket, deleteBucket, updateBucket, createBucketDefinition, updateBucketDefinition, deleteBucketDefinition, createBucketSchedule, updateBucketSchedule, deleteBucketSchedule, createBucketForcedRotationReset, updateBucketForcedRotationReset, deleteBucketForcedRotationReset, createBucketFreePeriodReset, updateBucketFreePeriodReset, deleteBucketFreePeriodReset, createBucketPeriod, updateBucketPeriod, deleteBucketPeriod, updateBucketPeriodChild } from '../../services/bucketsService';
import EMTable from '../Tables/EMTable';

import OutlinedTextField from '../OutlinedTextField'
import TitleToolbar from '../Forms/TitleToolbar';
import LoadingDialog from '../Dialogs/LoadingDialog';
import ScheduleForm from '../Forms/ScheduleForm';
import { useExecution } from '../../hooks/useExecution';
import { positionsService } from '../../services';
import moment from 'moment';
import { toDateObject } from '../../_helpers/dateConvert';
import DatePicker from "react-datepicker";
import { contextsActions } from '../../actions/contextsActions';
import { connect } from 'react-redux';
import MaskedInput from 'react-text-mask';
import { regexRules } from '../../_helpers/utility';
import CheckIcon from '@material-ui/icons/Check';

const __t = translate;

const styles = styleWithCommonClasses({
    paddingOnTop: {
        paddingTop: '20px'
    },
    upperCase: {
        textTransform: 'uppercase'
    },
    containerSelect: {
        width: '100%',
        padding: '4px'
    },
    errorBorder: {
        border: '1px solid red',
        borderRadius: '5px'
    },
})

const BucketContainerController = (props) => {
    const [buckets, setBuckets] = useState([]);
    const [loadingBuckets, setLoadingBuckets] = useState(true);
    const [bucketDefinitions, setBucketDefinitions] = useState([]);
    const [loadingBucketDefinitions, setLoadingBucketDefinitions] = useState(true);
    const [error, setError] = useState(null);
    const [positions, setPositions] = useState([]);

    const fetchContextPositionsQuery = useExecution(positionsService.getPositions);

    const fetchBuckets = useCallback(() => {
        fetchContextPositionsQuery.execute(props.contextId)
            .then(data => {
                setPositions(data);
            })
            .catch(err => {
                console.error('Error fetching positions:', err);
                setError('Unexpected Error');
            });

        getBuckets(props.contextId)
            .then(data => {
                console.log("buckets response", data);
                setBuckets(data);
                setLoadingBuckets(false);
            })
            .catch(err => {
                console.error('Error fetching reports:', error);
                setError('Unexpected Error');
            });
    }, [props.contextId]);

    const fetchBucketDefinitions = useCallback(() => {
        getBucketDefinitions(props.contextId)
            .then(data => {
                console.log("bucket definitions response", data);
                setBucketDefinitions(data);
                setLoadingBucketDefinitions(false);
            })
            .catch(err => {
                console.error('Error fetching bucket definitions:', err);
                setError('Unexpected Error');
            });
    }, [props.contextId]);

    useEffect(() => {
        fetchBuckets();
        fetchBucketDefinitions();
    }, [props.contextId]);

    if (loadingBuckets || loadingBucketDefinitions || fetchContextPositionsQuery.loading) {
        return (
            <Paper style={{ padding: '20px', textAlign: 'center' }}>
                <CircularProgress color='secondary' />
            </Paper>
        );
    }

    if (error) {
        return (
            <Paper style={{ padding: '20px', textAlign: 'center' }}>
                <div>{error}</div>
            </Paper>
        );
    }

    return (
        <BucketContainerPage
            contextId={props.contextId}
            positions={positions}
            buckets={buckets}
            setBuckets={setBuckets}
            bucketDefinitions={bucketDefinitions}
            setBucketDefinitions={setBucketDefinitions}
        />
    )
}

// BucketContainerController.propTypes = {
//     contextId: PropTypes.string.isRequired
// }

function mapDispatchToProps(dispatch) {
    return {
        setContextAsDraft: () => {
            dispatch(contextsActions.setAsDraft())
        }
    }
}

const BucketContainerPage = connect(null, mapDispatchToProps)(withStyles(styles)((props) => {
    const [bucketType, setBucketType] = useState(bucketTypes.FORCED_ROTATION); // FORCED_ROTATION 
    const [tableTabIndex, setTableTabIndex] = useState(0);
    const [disableTabs, setDisableTabs] = useState(false);

    const [message, setMessage] = useState({
        text: '',
        isError: false
    });

    return (
        <>
            <Tabs
                className={classNames(props.classes.tabPanel)}
                style={{ backgroundColor: 'white' }}
                value={bucketType == bucketTypes.FORCED_ROTATION ? 0 : 1}
                onChange={(e, index) => setBucketType(index == 0 ? bucketTypes.FORCED_ROTATION : bucketTypes.FREE_PERIODS)}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
            >
                <Tab key="bt-1" className={classNames(props.classes.tab)} label={__t('forced_rotation')} disabled={disableTabs}></Tab>
                <Tab key="bt-2" className={classNames(props.classes.nTab)} label={__t('free_periods')} disabled={disableTabs}></Tab>
            </Tabs>

            <Paper style={{ marginTop: '10px' }}>
                <div style={{ paddingLeft: '15px', paddingRight: '15px', paddingBottom: '10px' }}>
                    <div style={{ marginTop: '15px', border: '1px solid lightgray' }}>
                        <Tabs
                            className={classNames(props.classes.tabPanel)}
                            style={{ marginBottom: '10px' }}
                            value={tableTabIndex}
                            onChange={(e, index) => setTableTabIndex(index)}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            disabled={disableTabs}
                        >
                            <Tab key="bti-1" className={classNames(props.classes.tab)} label={__t('buckets')} disabled={disableTabs}></Tab>
                            <Tab key="bti-2" className={classNames(props.classes.nTab)} label={__t('definitions')} disabled={disableTabs}></Tab>
                        </Tabs>

                        <div style={{ paddingLeft: '15px', paddingRight: '15px', paddingBottom: '10px' }}>
                            {tableTabIndex == 0 ?
                                <BucketTablePage
                                    contextId={props.contextId}
                                    bucketType={bucketType}
                                    buckets={props.buckets.filter(b => b.bucketType == bucketType)}
                                    setBuckets={props.setBuckets}
                                    bucketDefinitions={props.bucketDefinitions.filter(bd => bd.bucketType == bucketType)}
                                    positions={props.positions}
                                    setDisableTabs={setDisableTabs}
                                    setMessage={setMessage}
                                    setContextAsDraft={props.setContextAsDraft}
                                />
                                :
                                <BucketDefinitionsTablePage
                                    contextId={props.contextId}
                                    bucketType={bucketType}
                                    buckets={props.buckets.filter(b => b.bucketType == bucketType)}
                                    bucketDefinitions={props.bucketDefinitions.filter(bd => bd.bucketType == bucketType)}
                                    setBucketDefinitions={props.setBucketDefinitions}
                                    setDisableTabs={setDisableTabs}
                                    setMessage={setMessage}
                                    setContextAsDraft={props.setContextAsDraft}
                                />
                            }
                        </div>
                    </div>
                </div>
                <Snackbar
                    open={!!(message.text)}
                    autoHideDuration={5000}
                    onClose={() => setMessage({ text: '', isError: false })}
                >
                    <SnackbarContent style={{ color: 'white', backgroundColor: message.isError ? 'red' : 'green' }} message={message.text} />
                </Snackbar>
            </Paper>
        </>
    )
}));

// // BucketContainerPage.propTypes = {
// //     contextId: PropTypes.string.isRequired,
// //     buckets: PropTypes.array.isRequired,
// //     bucketDefinitions: PropTypes.array.isRequired,
// // }

const BucketTablePage = withStyles(styles)((props) => {
    const [mode, setMode] = useState({
        type: 'table', // table | view | add | edit
        bucket: null
    });

    const [childIsInView, setChildIsInView] = useState(false);

    const createBucketQuery = useExecution(createBucket);
    const updateBucketQuery = useExecution(updateBucket);
    const deleteBucketQuery = useExecution(deleteBucket);

    const formRef = useRef(null);

    if (mode.type == 'table') {
        const columnDefinitions = [
            {
                id: 'name', align: 'center', disablePadding: false, label: `${__t('name')}`
            },
            {
                id: 'description', align: 'center', disablePadding: false, label: `${__t('description')}`
            },
            {
                id: 'bucketDefinitionName', align: 'center', disablePadding: false, label: `${__t('definition')}`
            },
        ];

        return (
            <div>
                <LoadingDialog loading={deleteBucketQuery.loading} />
                <EMTable
                    tableTitle={`${__t('buckets')}`}
                    dataSource={props.buckets}
                    rows={columnDefinitions}
                    onAdd={() => {
                        props.setDisableTabs(true);
                        setMode({ type: 'add', bucket: null });
                    }}
                    onView={(bucket) => {
                        props.setDisableTabs(true);
                        setMode({ type: 'view', bucket: bucket });
                    }}
                    onDelete={async (bucket) => {
                        try {
                            await deleteBucketQuery.execute(props.contextId, bucket.id);

                            props.setBuckets((buckets) => buckets.filter(b => b.id != bucket.id));
                            props.setContextAsDraft();
                        } catch (err) {
                            console.error('Error deleting bucket:', err);
                            props.setMessage({ isError: true, text: err });
                        }
                    }}
                />
            </div>

        );
    }

    return (
        <div>
            <TitleToolbar
                title={`${__t('bucket')}`}
                onCancel={!childIsInView && (mode.type == 'add' || mode.type == 'edit') ? () => {
                    if (mode.type == 'edit') {
                        setMode({ type: 'view', bucket: mode.bucket });
                    }
                    else {
                        props.setDisableTabs(false);
                        setMode({ type: 'table', bucket: null });
                    }
                } : undefined}
                onBack={!childIsInView && mode.type == 'view' ? () => {
                    props.setDisableTabs(false);
                    setMode({ type: 'table', bucket: null });
                } : undefined}
                onSave={!childIsInView && (mode.type == 'add' || mode.type == 'edit') ? async () => {
                    if (!formRef.current)
                        return;

                    const formData = formRef.current.getData();
                    if (!formData)
                        return;

                    try {
                        if (mode.type == 'add') {
                            const bucket = await createBucketQuery.execute(props.contextId, { ...formData, bucketType: props.bucketType });

                            props.setBuckets((buckets) => [...buckets, bucket].sort((a, b) => a.name.localeCompare(b.name)));
                        } else {
                            const bucket = await updateBucketQuery.execute(
                                props.contextId,
                                { id: mode.bucket.id, ...formData }
                            );

                            props.setBuckets((buckets) => buckets.map((b) => b.id === bucket.id ? bucket : b));
                        }

                        props.setContextAsDraft();
                        props.setDisableTabs(false);
                        setMode({ type: 'table', bucket: null });
                    } catch (err) {
                        console.error('Error saving bucket:', err);
                        props.setMessage({ isError: true, text: "error saving bucket" });
                    }
                } : undefined}
                onEdit={!childIsInView && mode.type == 'view' ? () => setMode({ type: 'edit', bucket: mode.bucket }) : undefined}
            >
                <BucketForm
                    key={`bucket-form-${mode.type}`}
                    ref={formRef}
                    bucket={mode.bucket}
                    bucketDefinitions={props.bucketDefinitions}
                    readonly={mode.type == 'view'}
                />
            </TitleToolbar>
            <LoadingDialog loading={createBucketQuery.loading || updateBucketQuery.loading} />
        </div>
    );
});

// const BucketPeriodController = (props) => {
//     const [mode, setMode] = useState({
//         type: 'table', // table | view | add | edit
//         bucketPeriod: null
//     });

//     const [childIsInView, setChildIsInView] = useState(false);

//     const createBucketPeriodQuery = useExecution(createBucketPeriod);
//     const updateBucketPeriodQuery = useExecution(updateBucketPeriod);
//     const deleteBucketPeriodQuery = useExecution(deleteBucketPeriod);

//     const formRef = useRef(null);

//     if (mode.type == 'table') {
//         const columnDefinitions = [
//             {
//                 id: 'name', align: 'center', disablePadding: false, label: `${__t('name')}`
//             },
//             {
//                 id: 'fromDate', align: 'center', disablePadding: false, label: `${__t('from')}`, formatter: function (value) {
//                     return toDateString(toDateObjectFromJson(value))
//                 }
//             },
//             {
//                 id: 'toDate', align: 'center', disablePadding: false, label: `${__t('to')}`, formatter: function (value) {
//                     return toDateString(toDateObjectFromJson(value))
//                 }
//             },
//             {
//                 id: 'multiplier', align: 'center', disablePadding: false, label: `${__t('multiplier')}`
//             },
//         ];

//         return (
//             <div>
//                 <LoadingDialog loading={deleteBucketPeriodQuery.loading} />
//                 <EMTable
//                     tableTitle={`${__t('periods')}`}
//                     dataSource={props.bucketPeriods}
//                     rows={columnDefinitions}
//                     onAdd={() => {
//                         props.setChildIsInView(true);
//                         setMode({ type: 'add', bucketPeriod: null });
//                     }}
//                     onView={(bucketPeriod) => {
//                         props.setChildIsInView(true);
//                         setMode({ type: 'view', bucketPeriod: bucketPeriod });
//                     }}
//                     onDelete={async (bucketPeriod) => {
//                         try {
//                             await deleteBucketPeriodQuery.execute(props.contextId, props.bucketId, bucketPeriod.id);

//                             props.setBuckets((buckets) => buckets.map(b => b.id == props.bucketId ? { ...b, periods: b.periods.filter(bp => bp.id != bucketPeriod.id) } : b));
//                             props.setContextAsDraft();
//                         } catch (err) {
//                             console.error('Error deleting bucket period:', err);
//                             props.setMessage({ isError: true, text: err });
//                         }
//                     }}
//                 />
//             </div>
//         );
//     }

//     return (
//         <div>
//             <LoadingDialog loading={createBucketPeriodQuery.loading || updateBucketPeriodQuery.loading} />
//             <TitleToolbar
//                 title={`${__t('periods')}`}
//                 onCancel={!childIsInView && (mode.type == 'add' || mode.type == 'edit') ? () => {
//                     if (mode.type == 'edit') {
//                         setMode({ type: 'view', bucketPeriod: mode.bucketPeriod });
//                     }
//                     else {
//                         props.setChildIsInView(false);
//                         setMode({ type: 'table', bucketPeriod: null });
//                     }
//                 } : undefined}
//                 onBack={!childIsInView && mode.type == 'view' ? () => {
//                     props.setChildIsInView(false);
//                     setMode({ type: 'table', bucketPeriod: null });
//                 } : undefined}
//                 onSave={!childIsInView && (mode.type == 'add' || mode.type == 'edit') ? async () => {
//                     if (!formRef.current)
//                         return;

//                     const formData = formRef.current.getData();
//                     if (!formData)
//                         return;

//                     try {
//                         if (mode.type == 'add') {
//                             const bucket = await createBucketPeriodQuery.execute(props.contextId, props.bucketId, formData);

//                             props.setBuckets((buckets) => buckets.map(b => b.id == props.bucketId ? { ...b, periods: [...b.periods, bucket].sort((a, b) => a.name.localeCompare(b.name)) } : b));
//                         } else {
//                             const bucket = await updateBucketPeriodQuery.execute(
//                                 props.contextId,
//                                 props.bucketId,
//                                 { ...mode.bucketPeriod, ...formData }
//                             );

//                             props.setBuckets((buckets) => buckets.map(b => b.id == props.bucketId ? { ...b, periods: b.periods.map(bp => bp.id == bucket.id ? bucket : bp) } : b));
//                         }

//                         props.setContextAsDraft();
//                         props.setChildIsInView(false);
//                         setMode({ type: 'table', bucket: null });
//                     } catch (err) {
//                         console.error('Error saving bucket:', err);
//                         props.setMessage({ isError: true, text: "error saving bucket" });
//                     }
//                 } : undefined}
//                 onEdit={!childIsInView && mode.type == 'view' ? () => setMode({ type: 'edit', bucketPeriod: mode.bucketPeriod }) : undefined}
//             >
//                 <BucketPeriodForm
//                     ref={formRef}
//                     bucketPeriod={mode.bucketPeriod}
//                     readonly={mode.type == 'view'}
//                 />
//                 {mode.type == 'view' ?
//                     <div style={{ marginTop: '20px', border: '1px solid lightgray', padding: '10px', paddingTop: '0px' }}>
//                         <BucketPeriodChildContainer
//                             contextId={props.contextId}
//                             bucketId={props.bucketId}
//                             positions={props.positions}
//                             bucketPeriod={props.bucketPeriods.find(bp => bp.id == mode.bucketPeriod.id)}
//                             setBuckets={props.setBuckets}
//                             childIsInView={childIsInView}
//                             setChildIsInView={setChildIsInView}
//                             setMessage={props.setMessage}
//                             setContextAsDraft={props.setContextAsDraft}
//                         />
//                     </div>
//                     :
//                     null
//                 }
//             </TitleToolbar>
//         </div>
//     );
// }

// const BucketPeriodChildContainer = withStyles(styles)((props) => {
//     const [child, setChild] = useState(0); // positions | groups | emission profiles

//     return (
//         <div>
//             <Tabs
//                 className={classNames(props.classes.tabPanel)}
//                 style={{ backgroundColor: 'white' }}
//                 value={child}
//                 onChange={(e, index) => setChild(index)}
//                 indicatorColor="primary"
//                 textColor="primary"
//                 variant="fullWidth"
//             >
//                 <Tab key="bt-1" className={classNames(props.classes.tab)} label={__t('positions')} disabled={props.childIsInView}></Tab>
//                 <Tab key="bt-2" className={classNames(props.classes.nTab)} label={__t('groups')} disabled={props.childIsInView}></Tab>
//                 <Tab key="bt-3" className={classNames(props.classes.nTab)} label={__t('emission_profiles')} disabled={props.childIsInView}></Tab>
//             </Tabs>

//             <div style={{ paddingLeft: '15px', paddingRight: '15px', paddingBottom: '10px' }}>
//                 {child == 0 ?
//                     <BucketPeriodPositionController
//                         contextId={props.contextId}
//                         bucketId={props.bucketId}
//                         bucketPeriodId={props.bucketPeriod.id}
//                         positions={props.positions}
//                         periodPositions={props.bucketPeriod.positions}
//                         setBuckets={props.setBuckets}
//                         setChildIsInView={props.setChildIsInView}
//                         setMessage={props.setMessage}
//                         setContextAsDraft={props.setContextAsDraft}
//                     />
//                     :
//                     <BucketPeriodAuxController
//                         contextId={props.contextId}
//                         bucketId={props.bucketId}
//                         bucketPeriodId={props.bucketPeriod.id}
//                         type={child == 1 ? 'groups' : 'emission_profiles'}
//                         values={child == 1 ? props.bucketPeriod.groups : props.bucketPeriod.emissionProfiles}
//                         setBuckets={props.setBuckets}
//                         setChildIsInView={props.setChildIsInView}
//                         setMessage={props.setMessage}
//                         setContextAsDraft={props.setContextAsDraft}
//                     />
//                 }
//             </div>
//         </div>
//     )
// })

// const BucketPeriodPositionController = withStyles(styles)((props) => {
//     const [isEditing, setIsEditing] = useState(false);
//     const [treeData, setTreeData] = useState(TreeState.create(props.positions.map(p => {
//         return {
//             data: {
//                 ...p,
//                 checked: props.periodPositions.some(pp => pp.code == p.code)
//             }
//         }
//     })))

//     const updatePositionsQuery = useExecution(updateBucketPeriodChild);

//     if (isEditing) {
//         return (
//             <TitleToolbar
//                 title={`${__t('edit')} ${__t('positions')}`}
//                 onCancel={() => {
//                     props.setChildIsInView(false);
//                     setIsEditing(false);
//                 }}
//                 onSave={async () => {
//                     const selectedPositions = treeData.data.filter(n => n.data.checked).map(n => n.data.id);

//                     try {
//                         await updatePositionsQuery.execute(props.contextId, props.bucketId, props.bucketPeriodId, "POSITIONS", selectedPositions);

//                         props.setBuckets((buckets) => buckets.map(b => b.id == props.bucketId ? { ...b, periods: b.periods.map(bp => bp.id == props.bucketPeriodId ? { ...bp, positions: treeData.data.filter(n => n.data.checked).map(n => ({ id: n.data.id, code: n.data.code, name: n.data.name })) } : bp) } : b));

//                         setIsEditing(false);
//                         props.setContextAsDraft();
//                         props.setChildIsInView(false);
//                     } catch (error) {
//                         console.error('Error updating positions:', error);
//                         props.setMessage({ text: error, isError: true });
//                     }
//                 }}
//             >
//                 <LoadingDialog loading={updatePositionsQuery.loading} />
//                 <TreeTable
//                     value={treeData}
//                     onChange={(treeValue) => {
//                         setTreeData(treeValue);
//                     }}
//                 >
//                     <TreeTable.Column
//                         renderCell={(row) => <div style={{
//                             height: "100%",
//                             display: "flex",
//                             flexDirection: "row",
//                             alignItems: "center"
//                         }}>
//                             <span>{row.data.name}</span>
//                         </div>}
//                         renderHeaderCell={() => <span>{__t('name')}</span>}
//                     />
//                     <TreeTable.Column
//                         renderCell={(row) => <div style={{
//                             height: "100%",
//                             display: "flex",
//                             flexDirection: "row",
//                             alignItems: "center"
//                         }}>
//                             <span>{row.data.code}</span>
//                         </div>}
//                         renderHeaderCell={() => <span>{__t('code')}</span>}
//                     />
//                     <TreeTable.Column
//                         renderCell={(row) => <div style={{
//                             height: "100%",
//                             display: "flex",
//                             flexDirection: "row",
//                             alignItems: "center"
//                         }}>
//                             <Switch
//                                 checked={row.data.checked}
//                                 onChange={() => {
//                                     row.updateData({ ...row.data, checked: !row.data.checked });
//                                 }}
//                             />
//                         </div>}
//                         renderHeaderCell={() => <span></span>}
//                     />
//                 </TreeTable>
//             </TitleToolbar>
//         )
//     }

//     const columnDefinitions = [
//         { id: 'name', align: 'center', disablePadding: false, label: __t('name') },
//         { id: 'code', align: 'center', disablePadding: false, label: __t('code') },
//     ];

//     return (
//         <div>
//             <EMTable
//                 tableTitle={__t('positions')}
//                 dataSource={props.periodPositions}
//                 rows={columnDefinitions}
//                 onTableEdit={() => {
//                     setIsEditing(true);
//                     props.setChildIsInView(true);
//                 }}
//             />
//         </div>
//     )
// });

// const BucketPeriodAuxController = withStyles(styles)((props) => {
//     const [isEditing, setIsEditing] = useState(false);

//     const updateChildQuery = useExecution(updateBucketPeriodChild);

//     const tableSubmitRef = useRef();

//     if (isEditing) {
//         return (
//             <div>
//                 <LoadingDialog loading={updateChildQuery.loading} />
//                 <TitleToolbar
//                     title={`${__t('edit')} ${__t(props.type == 'groups' ? 'groups' : 'emission_profiles')}`}
//                     onCancel={() => {
//                         setIsEditing(false);
//                         props.setChildIsInView(false);
//                     }}
//                     onSave={async () => {
//                         if (!tableSubmitRef.current)
//                             return;

//                         const finalValues = tableSubmitRef.current();

//                         try {
//                             await updateChildQuery.execute(props.contextId, props.bucketId, props.bucketPeriodId, props.type.toUpperCase(), finalValues);

//                             props.setBuckets((buckets) => buckets.map(b => b.id == props.bucketId ? { ...b, periods: b.periods.map(bp => bp.id == props.bucketPeriodId ? { ...bp, [(props.type == 'groups' ? 'groups' : 'emissionProfiles')]: finalValues } : bp) } : b));

//                             setIsEditing(false);
//                             props.setContextAsDraft();
//                             props.setChildIsInView(false);
//                         } catch (err) {
//                             console.error('Error saving bucket period child:', err);
//                             props.setMessage({ isError: true, text: "error saving " + (props.type == 'groups' ? 'groups' : 'emission profiles') });
//                         }
//                     }}
//                 >
//                     <CellTextTable
//                         refReturnData={(returnData) => { tableSubmitRef.current = returnData }}
//                         values={props.values}
//                         type="text"
//                     />
//                 </TitleToolbar>
//             </div >
//         )
//     }

//     const values = props.values.map((v, i) => ({ val: v, id: i }));
//     return (
//         <div>
//             <EMTable
//                 tableTitle={__t(props.type == 'groups' ? 'groups' : 'emission_profiles')}
//                 dataSource={values}
//                 rows={[
//                     { id: 'val', align: 'center', disablePadding: false, label: '' }
//                 ]}
//                 customTableButton={
//                     <Button
//                         // style={{ marginRight: '15px' }}
//                         color="primary"
//                         variant="outlined"
//                         onClick={() => {
//                             setIsEditing(true);
//                             props.setChildIsInView(true);
//                         }}
//                     >
//                         {__t('edit')}
//                     </Button>
//                 }
//             />
//         </div>
//     )
// })

// BucketTablePage.propTypes = {
//     contextId: PropTypes.string.isRequired,
//     buckets: PropTypes.array.isRequired,
// }

const BucketDefinitionsTablePage = withStyles(styles)((props) => {
    console.log("bucket definitions table page", props);
    const [mode, setMode] = useState({
        type: 'table', // table | view | add | edit
        bucketDefinition: null
    });

    const [childIsInView, setChildIsInView] = useState(false);

    const createBucketDefinitionQuery = useExecution(createBucketDefinition);
    const updateBucketDefinitionQuery = useExecution(updateBucketDefinition);
    const deleteBucketDefinitionQuery = useExecution(deleteBucketDefinition);

    const formRef = useRef(null);

    if (mode.type == 'table') {
        const columnDefinitions = [
            {
                id: 'name', align: 'center', disablePadding: false, label: `${__t('name')}`
            }
        ];

        return (
            <div>
                <LoadingDialog loading={deleteBucketDefinitionQuery.loading} />
                <EMTable
                    tableTitle={`${__t('definitions')}`}
                    dataSource={props.bucketDefinitions}
                    rows={columnDefinitions}
                    onAdd={() => {
                        props.setDisableTabs(true);
                        setMode({ type: 'add', bucketDefinition: null });
                    }}
                    onView={(bucketDefinition) => {
                        props.setDisableTabs(true);
                        setMode({ type: 'view', bucketDefinition: bucketDefinition });
                    }}
                    onDelete={async (bucketDefinition) => {
                        try {
                            await deleteBucketDefinitionQuery.execute(props.contextId, bucketDefinition.id);

                            props.setBucketDefinitions((bucketDefinitions) => bucketDefinitions.filter(bd => bd.id != bucketDefinition.id));
                            props.setContextAsDraft();
                        } catch (err) {
                            console.error('Error deleting bucket definition:', err);
                            props.setMessage({ isError: true, text: err });
                        }
                    }}
                />
            </div>
        );
    }

    return (
        <div>
            <LoadingDialog loading={createBucketDefinitionQuery.loading || updateBucketDefinitionQuery.loading} />
            <TitleToolbar
                title={`${__t('definition')}`}
                onCancel={!childIsInView && (mode.type == 'add' || mode.type == 'edit') ? () => {
                    if (mode.type == 'edit') {
                        setMode({ type: 'view', bucketDefinition: mode.bucketDefinition });
                    }
                    else {
                        props.setDisableTabs(false);
                        setMode({ type: 'table', bucketDefinition: null });
                    }
                } : undefined}
                onBack={!childIsInView && mode.type == 'view' ? () => {
                    props.setDisableTabs(false);
                    setMode({ type: 'table', bucketDefinition: null });
                } : undefined}
                onSave={!childIsInView && (mode.type == 'add' || mode.type == 'edit') ? () => {
                    if (!formRef.current)
                        return;

                    const formData = formRef.current.getData();

                    if (!formData)
                        return;

                    try {
                        if (mode.type == 'add') {
                            createBucketDefinitionQuery.execute(props.contextId, { ...formData, bucketType: props.bucketType })
                                .then((bucketDefinition) => {
                                    console.log("Created bucket definition:", bucketDefinition);
                                    props.setBucketDefinitions((bucketDefinitions) => [...bucketDefinitions, bucketDefinition].sort((a, b) => a.name.localeCompare(b.name)));

                                    props.setContextAsDraft();
                                    props.setDisableTabs(false);
                                    setMode({ type: 'table', bucketDefinition: null });
                                })
                                .catch((err) => {
                                    console.error('Error creating bucket definition:', err);
                                    props.setMessage({ isError: true, text: err });
                                });
                        } else {
                            updateBucketDefinitionQuery.execute(
                                props.contextId,
                                { ...mode.bucketDefinition, ...formData }
                            )
                                .then((bucketDefinition) => {
                                    props.setBucketDefinitions((bucketDefinitions) => bucketDefinitions.map((bd) => bd.id === bucketDefinition.id ? bucketDefinition : bd));

                                    props.setContextAsDraft();
                                    props.setDisableTabs(false);
                                    setMode({ type: 'table', bucketDefinition: null });
                                })
                                .catch((err) => {
                                    console.error('Error updating bucket definition:', err);
                                    props.setMessage({ isError: true, text: err });
                                });
                        }
                    } catch (err) {
                        console.error('Error saving bucket definition:', err);
                    }
                } : undefined}
                onEdit={!childIsInView && mode.type == 'view' ? () => setMode({ type: 'edit', bucketDefinition: mode.bucketDefinition }) : undefined}
            >
                <BucketDefinitionForm
                    key={`bucket-def-form-${mode.type}`}
                    ref={formRef}
                    bucketDefinition={mode.bucketDefinition}
                    readonly={mode.type == 'view'}
                />
                {mode.type == 'view' ?
                    <div style={{ marginTop: '20px', border: '1px solid lightgray', padding: '10px' }}>
                        <BucketScheduleController
                            contextId={props.contextId}
                            bucketType={props.bucketType}
                            bucketDefinitionId={mode.bucketDefinition.id}
                            bucketSchedules={props.bucketDefinitions.find((bd) => bd.id == mode.bucketDefinition.id).bucketSchedules}
                            setBucketDefinitions={props.setBucketDefinitions}
                            setChildIsInView={setChildIsInView}
                            setMessage={props.setMessage}
                            setContextAsDraft={props.setContextAsDraft}
                        />
                    </div>
                    :
                    null
                }
            </TitleToolbar>
        </div>
    );
});

const BucketScheduleController = (props) => {
    console.log("Rendering BucketScheduleController", props);
    const [mode, setMode] = useState({
        type: 'table', // table | view | add | edit
        bucketSchedule: null
    });

    const [childIsInView, setChildIsInView] = useState(false);

    const createBucketScheduleQuery = useExecution(createBucketSchedule);
    const updateBucketScheduleQuery = useExecution(updateBucketSchedule);
    const deleteBucketScheduleQuery = useExecution(deleteBucketSchedule);

    const formReturnFunction = useRef(null);

    if (mode.type == 'table') {
        const columnDefinitions = [
            {
                id: 'daysBitMask', align: 'center', disablePadding: false, label: `${__t('days')}`, formatter: function (value) {
                    let days = [];

                    const sDays = String(value);
                    if (sDays.includes("1"))
                        days.push(__t('monday'));
                    if (sDays.includes("2"))
                        days.push(__t('tuesday'));
                    if (sDays.includes("3"))
                        days.push(__t('wednesday'));
                    if (sDays.includes("4"))
                        days.push(__t('thursday'));
                    if (sDays.includes("5"))
                        days.push(__t('friday'));
                    if (sDays.includes("6"))
                        days.push(__t('saturday'));
                    if (sDays.includes("7"))
                        days.push(__t('sunday'));

                    return days.join(', ')
                }
            }
        ];

        return (
            <div>
                <LoadingDialog loading={deleteBucketScheduleQuery.loading} />
                <EMTable
                    tableTitle={`${__t('schedules')}`}
                    dataSource={props.bucketSchedules}
                    rows={columnDefinitions}
                    onAdd={() => {
                        props.setChildIsInView(true);
                        setMode({ type: 'add', bucketSchedule: null });
                    }}
                    onView={(bucketSchedule) => {
                        props.setChildIsInView(true);
                        setMode({ type: 'view', bucketSchedule: bucketSchedule });
                    }}
                    onDelete={async (bucketSchedule) => {
                        try {
                            await deleteBucketScheduleQuery.execute(props.contextId, props.bucketDefinitionId, bucketSchedule.id);

                            props.setBucketDefinitions((bds) => bds.map(bd => bd.id == props.bucketDefinitionId ? { ...bd, bucketSchedules: bd.bucketSchedules.filter(bs => bs.id != bucketSchedule.id) } : bd));
                            props.setContextAsDraft();
                        } catch (err) {
                            console.error('Error deleting bucket schedule:', err);
                            props.setMessage({ isError: true, text: err });
                        }
                    }}
                />
            </div>
        );
    }

    return (
        <div>
            <LoadingDialog loading={createBucketScheduleQuery.loading || updateBucketScheduleQuery.loading} />
            <TitleToolbar
                title={`${__t('schedule')}`}
                onCancel={!childIsInView && (mode.type == 'add' || mode.type == 'edit') ? () => {
                    if (mode.type == 'edit') {
                        setMode({ type: 'view', bucketSchedule: mode.bucketSchedule });
                    }
                    else {
                        props.setChildIsInView(false);
                        setMode({ type: 'table', bucketSchedule: null });
                    }
                } : undefined}
                onBack={!childIsInView && mode.type == 'view' ? () => {
                    props.setChildIsInView(false);
                    setMode({ type: 'table', bucketSchedule: null });
                } : undefined}
                onSave={!childIsInView && (mode.type == 'add' || mode.type == 'edit') ? () => {
                    if (formReturnFunction.current == null)
                        return;

                    const data = formReturnFunction.current();

                    if (data.formError)
                        return;

                    try {
                        if (mode.type == 'add') {
                            createBucketScheduleQuery.execute(props.contextId, props.bucketDefinitionId, data.formData)
                                .then((bucketSchedule) => {
                                    props.setBucketDefinitions((bucketDefinitions) => bucketDefinitions.map((bd) => bd.id === props.bucketDefinitionId ? { ...bd, bucketSchedules: [...bd.bucketSchedules, { ...bucketSchedule }].sort((a, b) => a.daysBitMask.localeCompare(b.daysBitMask)) } : bd));

                                    props.setContextAsDraft();
                                    props.setChildIsInView(false);
                                    setMode({ type: 'table', bucketSchedule: null });
                                })
                                .catch((err) => {
                                    console.error('Error creating bucket definition:', err);
                                    props.setMessage({ isError: true, text: err });
                                });
                        } else {
                            updateBucketScheduleQuery.execute(
                                props.contextId,
                                props.bucketDefinitionId,
                                { ...mode.bucketSchedule, ...data.formData }
                            )
                                .then((bucketSchedule) => {
                                    props.setBucketDefinitions((bucketDefinitions) => bucketDefinitions.map((bd) => bd.id === props.bucketDefinitionId ? { ...bd, bucketSchedules: bd.bucketSchedules.map((bs) => bs.id === bucketSchedule.id ? { ...bs, ...bucketSchedule } : bs) } : bd));

                                    props.setContextAsDraft();
                                    props.setChildIsInView(false);
                                    setMode({ type: 'table', bucketSchedule: null });
                                })
                                .catch((err) => {
                                    console.error('Error updating bucket definition:', err);
                                    props.setMessage({ isError: true, text: err });
                                });
                        }
                    } catch (err) {
                        console.error('Error saving bucket definition:', err);
                    }
                } : undefined}
                onEdit={!childIsInView && mode.type == 'view' ? () => setMode({ type: 'edit', bucketSchedule: mode.bucketSchedule }) : undefined}
            >
                <ScheduleForm
                    key={"schedule-form-" + mode.type}
                    refReturnData={(returnData) => {
                        formReturnFunction.current = returnData;
                    }}
                    schedule={mode.bucketSchedule}
                    readonly={mode.type == 'view'}
                />
                {mode.type == 'view' ?
                    <div style={{ marginTop: '20px', border: '1px solid lightgray', padding: '10px' }}>
                        <BucketResetController
                            contextId={props.contextId}
                            bucketType={props.bucketType}
                            bucketScheduleId={mode.bucketSchedule.id}
                            resets={props.bucketType == bucketTypes.FORCED_ROTATION ? props.bucketSchedules.find(bs => bs.id == mode.bucketSchedule.id).bucketForcedRotationResets : props.bucketSchedules.find(bs => bs.id == mode.bucketSchedule.id).bucketFreePeriodResets}
                            setBucketDefinitions={props.setBucketDefinitions}
                            setChildIsInView={setChildIsInView}
                            setMessage={props.setMessage}
                            setContextAsDraft={props.setContextAsDraft}
                        />
                    </div>
                    :
                    null
                }
            </TitleToolbar>
        </div>
    );
}

function getResetColumnDefinition(bucketType) {
    if (bucketType == bucketTypes.FORCED_ROTATION)
        return [
            {
                id: 'resetType', align: 'center', disablePadding: false, label: `${__t('type')}`
            },
            {
                id: 'startHour', align: 'center', disablePadding: false, label: `${__t('start_hour')}`
            },
            // {
            //     id: 'maxDurationAfterReset', align: 'center', disablePadding: false, label: `${__t('max_duration_after_reset')}`
            // },
            // {
            //     id: 'maxParkingDuration', align: 'center', disablePadding: false, label: `${__t('max_parking_duration')}`
            // },
            // {
            //     id: 'bufferDuration', align: 'center', disablePadding: false, label: `${__t('buffer_duration')}`
            // },
            // {
            //     id: 'automaticResetAfterBufferDuration', align: 'center', disablePadding: false, label: `${__t('automatic_reset')}`
            // },
        ];

    return [
        {
            id: 'startHour', align: 'center', disablePadding: false, label: `${__t('start_hour')}`
        },
        {
            id: 'freePeriod', align: 'center', disablePadding: false, label: `${__t('time')}`
        },
        {
            id: 'divisible', align: 'center', disablePadding: false, label: `${__t('divisible')}`, formatter: function (value) {
                return value ? <CheckIcon /> : null;
            }
        },
    ];
}

const BucketResetController = (props) => {
    const [mode, setMode] = useState({
        type: 'table', // table | view | add | edit
        reset: null
    });

    const createResetQuery = useExecution(props.bucketType == bucketTypes.FORCED_ROTATION ? createBucketForcedRotationReset : createBucketFreePeriodReset);
    const updateResetQuery = useExecution(props.bucketType == bucketTypes.FORCED_ROTATION ? updateBucketForcedRotationReset : updateBucketFreePeriodReset);
    const deleteResetQuery = useExecution(props.bucketType == bucketTypes.FORCED_ROTATION ? deleteBucketForcedRotationReset : deleteBucketFreePeriodReset);

    const formRef = useRef(null);

    const columnDefinitions = getResetColumnDefinition(props.bucketType);

    if (mode.type == 'table') {
        return (
            <div>
                <LoadingDialog loading={deleteResetQuery.loading} />
                <EMTable
                    tableTitle={`${__t('resets')}`}
                    dataSource={props.resets}
                    rows={columnDefinitions}
                    onAdd={() => {
                        props.setChildIsInView(true);
                        setMode({ type: 'add', reset: null });
                    }}
                    onView={(reset) => {
                        props.setChildIsInView(true);
                        setMode({ type: 'view', reset: reset });
                    }}
                    onDelete={async (reset) => {
                        try {
                            await deleteResetQuery.execute(props.contextId, props.bucketScheduleId, reset.id);

                            props.setBucketDefinitions((bds) => bds.map(bd => ({ ...bd, bucketSchedules: bd.bucketSchedules.map(bs => bs.id == props.bucketScheduleId ? { ...bs, [props.bucketType == bucketTypes.FORCED_ROTATION ? 'bucketForcedRotationResets' : 'bucketFreePeriodResets']: bs[props.bucketType == bucketTypes.FORCED_ROTATION ? 'bucketForcedRotationResets' : 'bucketFreePeriodResets'].filter(r => r.id != reset.id) } : bs) })));
                            props.setContextAsDraft();
                        } catch (err) {
                            console.error('Error deleting bucket reset:', err);
                            props.setMessage({ isError: true, text: err });
                        }
                    }}
                />
            </div>
        );
    }

    return (
        <div>
            <LoadingDialog loading={createResetQuery.loading || updateResetQuery.loading} />
            <TitleToolbar
                title={`${__t('reset')}`}
                onCancel={mode.type == 'add' || mode.type == 'edit' ? () => {
                    if (mode.type == 'edit') {
                        setMode({ type: 'view', reset: mode.reset });
                    }
                    else {
                        props.setChildIsInView(false);
                        setMode({ type: 'table', reset: null });
                    }
                } : undefined}
                onBack={mode.type == 'view' ? () => {
                    props.setChildIsInView(false);
                    setMode({ type: 'table', reset: null });
                } : undefined}
                onSave={mode.type == 'add' || mode.type == 'edit' ? () => {
                    if (formRef.current == null)
                        return;

                    const data = formRef.current.getData();

                    if (!data)
                        return;

                    try {
                        if (mode.type == 'add') {
                            createResetQuery.execute(props.contextId, props.bucketScheduleId, data)
                                .then((reset) => {
                                    props.setBucketDefinitions((bucketDefinitions) => bucketDefinitions.map((bd) => ({ ...bd, bucketSchedules: bd.bucketSchedules.map((bs) => bs.id === props.bucketScheduleId ? { ...bs, [props.bucketType == bucketTypes.FORCED_ROTATION ? 'bucketForcedRotationResets' : 'bucketFreePeriodResets']: [...bs[props.bucketType == bucketTypes.FORCED_ROTATION ? 'bucketForcedRotationResets' : 'bucketFreePeriodResets'], { ...reset }].sort((a, b) => a.startHour.localeCompare(b.startHour)) } : bs) })));

                                    props.setContextAsDraft();
                                    props.setChildIsInView(false);
                                    setMode({ type: 'table', reset: null });
                                })
                                .catch((err) => {
                                    console.error('Error creating bucket definition:', err);
                                    props.setMessage({ isError: true, text: err });
                                });
                        } else {
                            updateResetQuery.execute(
                                props.contextId,
                                props.bucketScheduleId,
                                { ...data, id: mode.reset.id }
                            )
                                .then((reset) => {
                                    props.setBucketDefinitions((bucketDefinitions) => bucketDefinitions.map((bd) => ({ ...bd, bucketSchedules: bd.bucketSchedules.map((bs) => ({ ...bs, bucketForcedRotationResets: bs.bucketForcedRotationResets.map((fr) => fr.id === reset.id ? { ...fr, ...data } : fr), bucketFreePeriodResets: bs.bucketFreePeriodResets.map((fr) => fr.id === reset.id ? { ...fr, ...reset } : fr) })) })));

                                    props.setContextAsDraft();
                                    props.setChildIsInView(false);
                                    setMode({ type: 'table', reset: null });
                                })
                                .catch((err) => {
                                    console.error('Error updating bucket reset:', err);
                                    props.setMessage({ isError: true, text: err });
                                });
                        }
                    } catch (err) {
                        console.error('Error saving bucket reset:', err);
                    }
                } : undefined}
                onEdit={mode.type == 'view' ? () => setMode({ type: 'edit', reset: mode.reset }) : undefined}
            >
                {props.bucketType == bucketTypes.FORCED_ROTATION ?
                    <BucketForceResetForm
                        key={`reset-form-${mode.type}`}
                        ref={formRef}
                        reset={mode.reset}
                        readonly={mode.type == 'view'}
                    />
                    :
                    <BucketFreePeriodForm
                        key={`reset-form-${mode.type}`}
                        ref={formRef}
                        reset={mode.reset}
                        readonly={mode.type == 'view'}
                    />
                }
            </TitleToolbar>
        </div>
    );
};

const BucketForm = forwardRef((props, ref) => {
    const [name, setName] = useState(props.bucket ? props.bucket.name : "");
    const [nameError, setNameError] = useState(null);
    const [bucketDefinitionId, setBucketDefinitionId] = useState(props.bucket ? props.bucket.bucketDefinitionId : "");
    const [bucketDefinitionIdError, setbucketDefinitionIdError] = useState(null);
    const [description, setDescription] = useState(props.bucket ? props.bucket.description : "");
    const [descriptionError, setDescriptionError] = useState(false);

    useImperativeHandle(ref, () => ({
        getData: () => {
            let hasError = false;

            setNameError(null);
            setDescriptionError(false);
            setbucketDefinitionIdError(null);

            if (!name || name.trim() === '') {
                setNameError(__t('name_required'));
                hasError = true;
            }

            if (!description || description.trim() === '') {
                setDescriptionError(true);
                hasError = true;
            }

            if (!bucketDefinitionId || bucketDefinitionId.trim() === '') {
                setbucketDefinitionIdError(__t('definition_required'));
                hasError = true;
            }

            if (hasError)
                return false;

            return {
                name: name,
                bucketDefinitionId: bucketDefinitionId,
                description: description
            }
        }
    }))

    return (
        <Grid container spacing={8} direction="row" justify="flex-start" alignItems="center">
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('name')}:</InputLabel>
            </Grid>
            <Grid item xs={4}>
                <OutlinedTextField
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value.replace(" ", "_"))}
                    inputProps={{ maxLength: 25, style: { textTransform: 'uppercase' } }}
                    disabled={props.readonly}
                />
            </Grid>
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('definition')}:</InputLabel>
            </Grid>
            <Grid item xs={4}>
                <div>
                    <Select
                        style={{ width: '100%', padding: '5px', border: bucketDefinitionIdError ? '1px solid #f44336' : '', borderRadius: '4px' }}
                        value={bucketDefinitionId}
                        onChange={(e) => setBucketDefinitionId(e.target.value)}
                        disabled={props.readonly}
                    >
                        <MenuItem style={{ display: "none" }}></MenuItem>
                        {props.bucketDefinitions.map(bd => (
                            <MenuItem key={bd.id} value={bd.id}>{bd.name}</MenuItem>
                        ))}
                    </Select>
                </div>
            </Grid>
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('description')}:</InputLabel>
            </Grid>
            <Grid item xs={10}>
                <OutlinedTextField
                    value={description}
                    error={descriptionError}
                    onChange={(e) => setDescription(e.target.value)}
                    inputProps={{ maxLength: 50 }}
                    disabled={props.readonly}
                />
            </Grid>
        </Grid>
    );
})

const BucketPeriodForm = forwardRef((props, ref) => {
    const [name, setName] = useState(props.bucketPeriod ? props.bucketPeriod.name : "");
    const [nameError, setNameError] = useState(null);
    const [description, setDescription] = useState(props.bucketPeriod ? props.bucketPeriod.description : "");
    const [descriptionError, setDescriptionError] = useState(null);
    const [fromDate, setFromDate] = useState(props.bucketPeriod ? moment(props.bucketPeriod.fromDate).toDate() : "");
    const [fromDateError, setFromDateError] = useState(null);
    const [toDate, setToDate] = useState(props.bucketPeriod ? moment(props.bucketPeriod.toDate).toDate() : "");
    const [toDateError, setToDateError] = useState(null);
    const [multiplier, setMultiplier] = useState(props.bucketPeriod ? props.bucketPeriod.multiplier : "");
    const [multiplierError, setMultiplierError] = useState(null);

    useImperativeHandle(ref, () => ({
        getData: () => {
            let hasError = false;

            setNameError(null);
            setDescriptionError(null);
            setFromDateError(null);
            setToDateError(null);
            setMultiplierError(null);

            if (!name || name.trim() === '') {
                setNameError(__t('name_required'));
                hasError = true;
            }

            if (!fromDate || !moment(fromDate).isValid()) {
                setFromDateError(__t('from_date_required'));
                hasError = true;
            }

            if (!toDate || !moment(toDate).isValid()) {
                setToDateError(__t('to_date_required'));
                hasError = true;
            }

            if (moment(fromDate).isValid() && moment(toDate).isValid() && !moment(toDate).isAfter(moment(fromDate))) {
                setFromDateError(__t('from_date_must_be_before_to_date'));
                setToDateError(__t('to_date_must_be_after_from_date'));
                hasError = true;
            }

            if (hasError)
                return false;

            return {
                name: name,
                description: description,
                fromDate: moment(fromDate).format('YYYY-MM-DD'),
                toDate: moment(toDate).format('YYYY-MM-DD'),
                multiplier: multiplier
            }
        }
    }))

    return (
        <Grid container spacing={8} direction="row" justify="flex-start" alignItems="center">
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('name')}:</InputLabel>
            </Grid>
            <Grid item xs={4}>
                <OutlinedTextField
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value.replace(" ", "_"))}
                    inputProps={{ maxLength: 25, style: { textTransform: 'uppercase' } }}
                    disabled={props.readonly}
                />
            </Grid>
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('multiplier')}:</InputLabel>
            </Grid>
            <Grid item xs={4}>
                <OutlinedTextField
                    type="number"
                    value={multiplier}
                    error={multiplierError}
                    onChange={(e) => setMultiplier(e.target.value)}
                    disabled={props.readonly}
                />
            </Grid>
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('valid_from')} ({__t('inclusive')}):</InputLabel>
            </Grid>
            <Grid item xs={4}>
                <DatePicker
                    // locale={this.props.locale}
                    selected={fromDate}
                    dateFormat="dd/MM/yyyy"
                    todayButton={__t("today_label")}
                    disabledKeyboardNavigation
                    onChange={(date) => {
                        setFromDate(date)
                    }}
                    customInput={
                        <OutlinedTextField
                            readOnly={true}
                            hideLabel={true}
                            error={fromDateError}
                        />
                    }
                    maxDate={toDate && moment(toDate).isValid ? moment(toDate).add(-1, 'days').toDate() : toDateObject('31/12/2999')}
                    readOnly={props.readonly}
                />
            </Grid>
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('valid_to')} ({__t('exclusive')}):</InputLabel>
            </Grid>
            <Grid item xs={4}>
                <DatePicker
                    // locale={this.props.locale}
                    selected={toDate}
                    dateFormat="dd/MM/yyyy"
                    todayButton={__t("today_label")}
                    disabledKeyboardNavigation
                    onChange={(date) => {
                        setToDate(date)
                    }}
                    customInput={
                        <OutlinedTextField
                            readOnly={true}
                            hideLabel={true}
                            error={toDateError}
                        />
                    }
                    minDate={moment(fromDate).isValid ? moment(fromDate).add(1, 'days').toDate() : moment(new Date()).add(1, 'days').toDate()}
                    maxDate={toDateObject('01/01/3000')}
                    readOnly={props.readonly}
                />
            </Grid>
            <Grid item xs={2}>
                <InputLabel shrink>{__t('description')}:</InputLabel>
            </Grid>
            <Grid item xs={10}>
                <OutlinedTextField
                    value={description}
                    error={descriptionError}
                    onChange={(e) => setDescription(e.target.value)}
                    inputProps={{ maxLength: 50 }}
                    disabled={props.readonly}
                />
            </Grid>
        </Grid>
    );
})

const BucketDefinitionForm = forwardRef((props, ref) => {
    const [name, setName] = useState(props.bucketDefinition ? props.bucketDefinition.name : "");
    const [nameError, setNameError] = useState(null);

    useImperativeHandle(ref, () => ({
        getData: () => {
            setNameError(null);
            if (!name || name.trim() === '') {
                setNameError(__t('name_required'));
                return false;
            }

            return {
                name: name
            }
        }
    }))

    return (
        <Grid container spacing={8} direction="row" justify="flex-start" alignItems="center">
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('name')}:</InputLabel>
            </Grid>
            <Grid item xs={4}>
                <OutlinedTextField
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value.replace(" ", "_"))}
                    inputProps={{ maxLength: 25, style: { textTransform: 'uppercase' } }}
                    disabled={props.readonly}
                />
            </Grid>
            <Grid item xs={6}>
            </Grid>
        </Grid>
    )
});

const errorBorderStyle = {
    border: '1px solid #f44336',
    borderRadius: '4px'
}

const BucketForceResetForm = forwardRef((props, ref) => {
    const [type, setType] = useState(props.reset ? props.reset.resetType : "");
    const [typeError, setTypeError] = useState(null);
    const [startHour, setStartHour] = useState(props.reset ? props.reset.startHour : "");
    const [startHourError, setStartHourError] = useState(false);
    const [maxDurationAfterReset, setMaxDurationAfterReset] = useState(props.reset ? props.reset.maxDurationAfterReset : "");
    const [maxDurationAfterResetError, setMaxDurationAfterResetError] = useState(false);
    const [maxParkingDuration, setMaxParkingDuration] = useState(props.reset ? props.reset.maxParkingDuration : "");
    const [maxParkingDurationError, setMaxParkingDurationError] = useState(false);
    const [bufferDuration, setBufferDuration] = useState(props.reset ? props.reset.bufferDuration : "");
    const [bufferDurationError, setBufferDurationError] = useState(false);
    const [automaticResetAfterBufferDuration, setAutomaticResetAfterBufferDuration] = useState(props.reset ? props.reset.automaticResetAfterBufferDuration : false);
    const [automaticResetAfterBufferDurationError, setAutomaticResetAfterBufferDurationError] = useState(null);

    useImperativeHandle(ref, () => ({
        getData: () => {
            let hasError = false;

            setTypeError(null);
            setStartHourError(false);
            setMaxDurationAfterResetError(false);
            setMaxParkingDurationError(false);
            setBufferDurationError(false);
            setAutomaticResetAfterBufferDurationError(null);

            if (!type || type.trim() === '') {
                setTypeError(__t('type_required'));
                hasError = true;
            }

            if (!startHour || regexRules.startTime.test(startHour) === false) {
                setStartHourError(true);
                return false;
            }

            if (type == forceRotationResetTypes.FIXED) {
                if (!maxDurationAfterReset || regexRules.ptStringHhmm.test(maxDurationAfterReset) === false) {
                    setMaxDurationAfterResetError(true);
                    hasError = true;
                }
            }

            if (type == forceRotationResetTypes.SINGLE_SESSION_DYNAMIC || type == forceRotationResetTypes.MULTIPLE_SESSION_DYNAMIC) {
                if (!maxParkingDuration || regexRules.ptStringHhmm.test(maxParkingDuration) === false) {
                    setMaxParkingDurationError(true);
                    hasError = true;
                }

                if (!bufferDuration || regexRules.ptStringHhmm.test(bufferDuration) === false) {
                    setBufferDurationError(true);
                    hasError = true;
                }
            }

            if (hasError)
                return false;

            if (type == forceRotationResetTypes.FIXED)
                return {
                    resetType: type,
                    startHour: startHour,
                    maxDurationAfterReset: maxDurationAfterReset,
                }

            if (type == forceRotationResetTypes.SINGLE_SESSION_DYNAMIC)
                return {
                    resetType: type,
                    startHour: startHour,
                    maxParkingDuration: maxParkingDuration,
                    bufferDuration: bufferDuration,
                }

            return {
                resetType: type,
                startHour: startHour,
                maxParkingDuration: maxParkingDuration,
                bufferDuration: bufferDuration,
                automaticResetAfterBufferDuration: Boolean(automaticResetAfterBufferDuration),
            }
        }
    }))

    return (
        <Grid container spacing={8} direction="row" justify="flex-start" alignItems="center">
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('type')}:</InputLabel>
            </Grid>
            <Grid item xs={4}>
                {/* <div className={classNames(props.classes.containerSelect, typeError ? props.classes.errorBorder : '')}> */}
                <div>
                    <Select
                        style={{ width: '100%', padding: '5px', border: typeError ? '1px solid #f44336' : '', borderRadius: '4px' }}
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                        disabled={props.readonly}
                    >
                        <MenuItem style={{ display: "none" }}></MenuItem>
                        <MenuItem value={forceRotationResetTypes.FIXED}>{__t('fixed').toUpperCase()}</MenuItem>
                        <MenuItem value={forceRotationResetTypes.SINGLE_SESSION_DYNAMIC}>{__t('single_session_dynamic').toUpperCase()}</MenuItem>
                        <MenuItem value={forceRotationResetTypes.MULTIPLE_SESSION_DYNAMIC}>{__t('multiple_session_dynamic').toUpperCase()}</MenuItem>
                    </Select>
                </div>
            </Grid>
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('start_hour')} (HH:MM:SS):</InputLabel>
            </Grid>
            <Grid item xs={4}>
                <MaskedInput
                    style={{ width: '100%', padding: '10px', fontSize: '1em', ...(startHourError ? errorBorderStyle : {}) }}
                    value={startHour}
                    onChange={(e) => setStartHour(e.target.value)}
                    mask={[/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]}
                    guide={false}
                    placeholder="HH:MM:SS"
                    disabled={props.readonly}
                />
            </Grid>
            {type == forceRotationResetTypes.FIXED ?
                <>
                    <Grid item xs={2}>
                        <InputLabel shrink required>{__t('max_duration_after_reset')}:</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <MaskedInput
                            style={{ width: '100%', padding: '10px', fontSize: '1em', ...(maxDurationAfterResetError ? errorBorderStyle : {}) }}
                            value={maxDurationAfterReset}
                            onChange={(e) => setMaxDurationAfterReset(e.target.value)}
                            mask={[/[0-9]/, /[0-9]/, 'h', /[0-5]/, /[0-9]/, 'm']}
                            guide={false}
                            placeholder="00h00m"
                            disabled={props.readonly}
                        />
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                </>
                :
                type == forceRotationResetTypes.SINGLE_SESSION_DYNAMIC || type == forceRotationResetTypes.MULTIPLE_SESSION_DYNAMIC ?
                    <>
                        <Grid item xs={2}>
                            <InputLabel shrink required>{__t('max_parking_duration')}:</InputLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <MaskedInput
                                style={{ width: '100%', padding: '10px', fontSize: '1em', ...(maxParkingDurationError ? errorBorderStyle : {}) }}
                                value={maxParkingDuration}
                                onChange={(e) => setMaxParkingDuration(e.target.value)}
                                mask={[/[0-9]/, /[0-9]/, 'h', /[0-5]/, /[0-9]/, 'm']}
                                guide={false}
                                placeholder="00h00m"
                                disabled={props.readonly}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <InputLabel shrink required>{__t('buffer_duration')}:</InputLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <MaskedInput
                                style={{ width: '100%', padding: '10px', fontSize: '1em', ...(bufferDurationError ? errorBorderStyle : {}) }}
                                value={bufferDuration}
                                onChange={(e) => setBufferDuration(e.target.value)}
                                mask={[/[0-9]/, /[0-9]/, 'h', /[0-5]/, /[0-9]/, 'm']}
                                guide={false}
                                placeholder="00h00m"
                                disabled={props.readonly}
                            />
                        </Grid>
                        {type == forceRotationResetTypes.MULTIPLE_SESSION_DYNAMIC ?
                            <>
                                <Grid item xs={6}>
                                </Grid>
                                <Grid item xs={5}>
                                    <InputLabel shrink>{__t('automatic_reset')}:</InputLabel>
                                </Grid>
                                <Grid item xs={1}>
                                    <Checkbox disabled={props.readonly} checked={automaticResetAfterBufferDuration} onChange={() => setAutomaticResetAfterBufferDuration(!automaticResetAfterBufferDuration)} />
                                </Grid>
                            </>
                            :
                            null
                        }
                    </>
                    : null
            }
        </Grid>
    );
});

const BucketFreePeriodForm = forwardRef((props, ref) => {
    const [startHour, setStartHour] = useState(props.reset ? props.reset.startHour : "");
    const [startHourError, setStartHourError] = useState(false);
    const [divisible, setDivisible] = useState(props.reset ? props.reset.divisible : "");
    const [freePeriod, setFreePeriod] = useState(props.reset ? props.reset.freePeriod : "");
    const [freePeriodError, setFreePeriodError] = useState(false);

    useImperativeHandle(ref, () => ({
        getData: () => {
            setStartHourError(false);
            setFreePeriodError(false);

            let hasError = false;

            if (!startHour || regexRules.startTime.test(startHour) === false) {
                setStartHourError(true);
                hasError = true;
            }

            if (!freePeriod || regexRules.ptStringHhmm.test(freePeriod) === false) {
                setFreePeriodError(true);
                hasError = true;
            }

            if (hasError)
                return false;

            return {
                startHour: startHour,
                divisible: Boolean(divisible),
                freePeriod: freePeriod
            }
        }
    }))

    return (
        <Grid container spacing={8} direction="row" justify="flex-start" alignItems="center">
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('start_hour')}:</InputLabel>
            </Grid>
            <Grid item xs={4}>
                <MaskedInput
                    style={{ width: '100%', padding: '10px', fontSize: '1em', ...(startHourError ? errorBorderStyle : {}) }}
                    value={startHour}
                    onChange={(e) => setStartHour(e.target.value)}
                    mask={[/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]}
                    guide={false}
                    placeholder="HH:MM:SS"
                    disabled={props.readonly}
                />
            </Grid>
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('divisible')}:</InputLabel>
            </Grid>
            <Grid item xs={4}>
                <Checkbox disabled={props.readonly} checked={divisible} onChange={() => setDivisible(!divisible)} />
            </Grid>
            <Grid item xs={2}>
                <InputLabel shrink required>{__t('time')}:</InputLabel>
            </Grid>
            <Grid item xs={4}>
                <MaskedInput
                    style={{ width: '100%', padding: '10px', fontSize: '1em', ...(freePeriodError ? errorBorderStyle : {}) }}
                    value={freePeriod}
                    onChange={(e) => setFreePeriod(e.target.value)}
                    mask={[/[0-9]/, /[0-9]/, 'h', /[0-5]/, /[0-9]/, 'm']}
                    guide={false}
                    placeholder="00h00m"
                    disabled={props.readonly}
                />
            </Grid>
            <Grid item xs={6}>
            </Grid>
        </Grid>
    );
});

export default BucketContainerController;
